// eslint-disable-next-line no-unused-vars
const canRequire = typeof __webpack_require__ === 'function';



module.exports =
{
    branding: 'logo', // 'heute', 'logo'
    theme: 'light', // 'dark', 'light'
    // Meta Tags für Facebook, Twitter
    meta: {
        // Seiten Title
        title: 'Lernt alle Bundesländer Deutschlands kennen!',
        // Beschreibung
        description: 'Macht euch auf die Reise und lest hier die wichtigsten Infos zu den Ländern!',
        // Bild
        image: 'https://3d.zdf.de/deutschland-bundeslaender-karte-kinder-infos/img/social_card.jpg',
        // URL
        url: 'https://3d.zdf.de/deutschland-bundeslaender-karte-kinder-infos/',
    },
    tracking: {
        storyName: 'Logo-Tour',
        storyID: 'LogoTour',
        // Tracking deaktivieren
        //disabled: false,
    },
    babylon: {
        lightIntensity : 0,

        camera: {
            // Position, Ausrichtung und Kamera Bewegung
            // Kamera Position
            position: [-1.57, 0.1, 60], // alpha, beta, radius
            moveFunction: 'move', // Wie die Kamera bewegt wird: 'move' Kamerafahrt, 'set' Springt zur Position
            target: [0, 0, 1], // Wohin die Kamera blickt
            animationSpeed: 280, // Geschwindigkeit der Kamerabewegung

            // Begrenzungen
            alphaLimits: [-1.57,-1.569],
            betaLimits: [0.1,.1],
            radiusLimits: [3, 60], // minCamRadius, maxCamRadius
            clipping: [.5, 100],
            fov: 0.8,
            invertRotation: false, // Kamera Steuerung umkehren für 360° Sphere Ansicht
            stopOnClick: true, // Kamera Animation stoppen, bei klick

            // Automatisches Drehen
            useAutoRotationBehavior: false,
            idleRotationSpeed: 0.05,

            // Steuerung
            panSensibility: 0, // 0 is deactivated
            wheelPrecision: 30.0, // 3.0 ist Standard
        },
    },
    audio: {
        enabled: true,
        // Dauerhafte Hintergrund Musik
        //background: canRequire && require('./assets/audio/News_Loop3.mp3'),
    },
    objects:
    [
        {
            // Name des Objekts zur Ansteuerung
            name: "zdfLogo",
            // GLB Dateiname im Ordner app/public/3d-models
            filename: "ZDF_Logo.glb",
            options: {
                //// BaseObject
                // true: Objekt anzeigen
                visible: false,
                // Skalierung: Objekt Größe ändern in allen Dimensionen
                scaling: [1, 1, -1],
                // Skalierung: Objekt Größe ändern (Alle Dimensionen gleich)
                //scale: 0.01,
                // Position
                position: [0, 0, 0],
                // Rotation
                rotation: [0.5 * Math.PI, 0, 0],
                // Rotation Quaternion, siehe https://doc.babylonjs.com/features/position,_rotation,_scaling#rotationquaternion
                //rotationQuaternion: [0.707, 0, 0, 0.707],
                // Transparenz (0 bis 1)
                //visibility: 0.25,
                // RGB-Farbe (diffuse) jeweils Werte 0 bis 255
                //diffuse: [255, 0, 0],
                // Zur Kamera ausrichten
                // 1: X-Achse, 2: Y-Achse, 4: Z-Achse, 7: Alle Achsen
                // 3: X & Y-Achse, 5: Z & X-Achse, 6: Z & Y-Achse
                // https://doc.babylonjs.com/typedoc/classes/babylon.abstractmesh#billboardmode
                billboardMode: 0,
                // Overlay Color zum hervorheben von Objekten
                //overlayColor: [250/255, 125/255, 25/255],
                // Rendering Group ID legt Objekte eine ebene nach vorne (Auch beim Hotspot)
                //renderingGroupId: 1

                //// MeshObject
                // Objekt mit Fade ein und ausblenden, wenn visible sich ändert
                fade: false,
                // Unter-Mesh-Objekte in der Datei
                // Name des Meshs wie im 3D Model
                ZDF_Logo: {
                    visible: true,
                    fade: false,
                    // Ist das Objekt anklickbar?
                    // Bei true wird ein Hotspot durch das Objekt nicht anklickbar, wenn verdeckt.
                    // Darum sollte bei transparenten Objekten ggf. pickable: false gesetzt werden.
                    pickable: true,
                    // Texture auf Objekt durchgehend verschieben. Zum Beispiel für Lava oder Wasser.
                    // Die zwei Werte geben die Verschiebung-Geschwindigkeit pro Achse an.
                    //animateTexture: [ -0.001, 0 ],

                    ZDF_Logo_2: {
                        visible: true,
                        fade: false,
                    }
                },

                //// BabylonObject
                // animation=true: startet die Animation im Objekt
                animation: false,

                // Nur initial, nicht per babylonState
                // OnClick Trigger
                // trigger: function () { }
            },
            // Callback wenn Objekt geladen und erstellt wurde zum setzen weiterer Einstellungen.
            callback: function (zdfLogo) // eslint-disable-line no-unused-vars
            {

            }
        },
        // Dies koennte ein zweites Objekt sein, das ihr ladet.
        // {
        //     name: "templateObject",
        //     filename: "templateObject.glb",
        //     options: {
        //         visible: false,
        //         position: [0, 0, 0],
        //         scaling: [.1, .1, .1],
        //         rotation: [0, 5.17, 0],
        //     },
        // },

        // {
        //     name: "ZDF_Logo2",
        //     filename: "ZDF_Logo.glb",
        //     options: {
        //         visible: false,
        //         position: [0, 0, -5],
        //         scaling: [1, 1, -1],
        //         rotation: [0.5 * Math.PI, 0, 0],
        //         children: {
        //             ZDF_Logo: {
        //                 visible: true,
        //             },
        //             ZDF_Logo_2: {
        //                 visible: true,
        //             },
        //         },
        //     },
        // },
        {
            name: "karte",
            filename: "logotour.glb",
            options: {
                visible: true,
                position: [0, 0, 0],
                scaling: [1, 1, -1],
                rotation: [0, 0, 0],

                children: {


                    geo_sl:{
                        pickable: false,
                    },

                    geo_rp:{
                        pickable: false,
                    },

                    geo_he:{
                        renderingGroupId:1,
                        pickable: false,
                    },

                    geo_nw:{
                        pickable: false,
                    },

                    geo_ni:{
                        pickable: false,
                    },

                    geo_hb:{
                        pickable: false,
                    },

                    geo_mv:{
                        pickable: false,
                    },

                    geo_sh:{
                        pickable: false,
                    },

                    geo_hh:{
                        pickable: false,
                    },

                    geo_be:{
                        pickable: false,
                    },

                    geo_bb:{
                        pickable: false,
                    },

                    geo_st:{
                        pickable: false,
                        renderingGroupId:2,
                    },

                    geo_sn:{
                        pickable: false,
                    },

                    geo_th:{
                        pickable: false,
                        renderingGroupId:1,
                    },

                    geo_bw:{
                        pickable: false,
                    },

                    geo_by:{
                        pickable: false,
                    },

                    //Geo Marker

                    geo_marker_01: {
                        visible: false,
                        visibility: 0,
                        scaling: [1,1,1],
                        renderingGroupId:2,
                    },
                    geo_marker_02: {
                        visible: false,
                        visibility: 0,
                        scaling: [1,1,1],
                        renderingGroupId:2,
                    },
                    geo_marker_03: {
                        visible: false,            
                        visibility: 0,
                        scaling: [1,1,1],
                        renderingGroupId:2,
                    },
                    geo_marker_04: {
                        visible: false,
                        visibility: 0,
                        scaling: [1,1,1],
                        renderingGroupId:2,
                    },
                    geo_marker_05: {
                        visible: false,
                        visibility: 0,
                        scaling: [1,1,1],
                        renderingGroupId:2,
                    },
                    geo_marker_06: {
                        visible: false,
                        visibility: 0,
                        scaling: [1,1,1],
                        renderingGroupId:2,
                    },
                    geo_marker_07: {
                        visible: false,
                        visibility: 0,
                        scaling: [1,1,1],
                        renderingGroupId:2,
                    },
                    geo_marker_08: {
                        visible: false,
                        visibility: 0,
                        scaling: [1,1,1],
                        renderingGroupId:2,
                        //billboardMode:3,
                    },
                    geo_marker_09: {
                        visible: false,
                        visibility: 0,
                        renderingGroupId:3,
                    },
                    geo_marker_10: {
                        visible: false,
                        visibility: 0,
                        scaling: [1,1,1],
                        renderingGroupId:2,
                    },
                    geo_marker_11: {
                        visible: false,
                        visibility: 0,
                        scaling: [1,1,1],
                        renderingGroupId:3,
                    },
                    geo_marker_12: {
                        visible: false,
                        visibility: 0,
                        scaling: [1,1,1],
                        renderingGroupId:3,
                    },
                    geo_marker_13: {
                        visible: false,
                        visibility: 0,
                        renderingGroupId:3,
                    },
                    geo_marker_14: {
                        visible: false,
                        visibility: 0,
                        scaling: [1,1,1],
                        renderingGroupId:2,
                    },
                    geo_marker_15: {
                        visible: false,
                        visibility: 0,
                        scaling: [1,1,1],
                        renderingGroupId:2,
                    },
                    geo_marker_16: {
                        visible: false,
                        visibility: 0,
                        scaling: [1,1,1],
                        renderingGroupId:2,

                    },

                    hand_01:{
                        visible: false,
                        position: [-1.5,2,4.8],
                        scale: .44,
                        geo_hand_01:{
                            renderingGroupId:2,
                            pickable: false,
                            visible: false,
                        },
                    },

                    hand_02:{
                        visible: false,
                        geo_hand_02:{
                            visible: false,
                            renderingGroupId:3,
                        },
                    },

                    //Sehenswürdigkeiten

                    geo_sw_sl_1:{
                        visibility:0,
                        pickable: false,
                    },
                    geo_sw_sl_2:{
                        visibility:0,
                        renderingGroupId:1,
                        pickable: false,
                    },

                    geo_sw_rp_1:{
                        visibility:0,
                        renderingGroupId:1,
                        pickable: false,

                    },
                    geo_sw_rp_2:{
                        visibility:0,
                        renderingGroupId:1,
                        pickable: false,
                    },

                    geo_sw_he_1:{
                        visibility:0,
                        renderingGroupId:1,
                        pickable: false,

                    },
                    geo_sw_he_2:{
                        visibility:0,
                        renderingGroupId:2,
                        pickable: false,
                    },

                    geo_sw_nw_1:{
                        visibility:0,
                        renderingGroupId:2,
                        pickable: false,

                    },
                    geo_sw_nw_2:{
                        visibility:0,
                        renderingGroupId:2,
                        pickable: false,
                    },

                    geo_sw_ni_1:{
                        visibility:0,
                        renderingGroupId:2,
                        pickable: false,

                    },
                    geo_sw_ni_2:{
                        visibility:0,
                        renderingGroupId:2,
                        pickable: false,
                    },

                    geo_sw_hb_1:{
                        visibility:0,
                        pickable: false,
                    },
                    geo_sw_hb_2:{
                        visibility:0,
                        renderingGroupId:1,
                        pickable: false,
                    },

                    geo_sw_mv_1:{
                        visibility:0,
                        renderingGroupId:1,
                        pickable: false,

                    },
                    geo_sw_mv_2:{
                        visibility:0,
                        renderingGroupId:1,
                        pickable: false,
                    },

                    geo_sw_sh_1:{
                        visibility:0,
                        renderingGroupId:1,
                        pickable: false,

                    },
                    geo_sw_sh_2:{
                        visibility:0,
                        renderingGroupId:1,
                        pickable: false,
                    },

                    geo_sw_hh_1:{
                        visibility:0,
                        renderingGroupId:1,
                        pickable: false,

                    },
                    geo_sw_hh_2:{
                        visibility:0,
                        renderingGroupId:1,
                        pickable: false,
                    },

                    geo_sw_be_1:{
                        visibility:0,
                        renderingGroupId:2,
                        pickable: false,

                    },
                    geo_sw_be_2:{
                        visibility:0,
                        renderingGroupId:2,
                        pickable: false,
                    },

                    geo_sw_bb_1:{
                        visibility:0,
                        renderingGroupId:1,
                        pickable: false,

                    },
                    geo_sw_bb_2:{
                        visibility:0,
                        renderingGroupId:1,
                        pickable: false,
                    },

                    geo_sw_st_1:{
                        visibility:0,
                        renderingGroupId:3,
                        pickable: false,

                    },
                    geo_sw_st_2:{
                        visibility:0,
                        renderingGroupId:3,
                        pickable: false,
                    },

                    geo_sw_sn_1:{
                        visibility:0,
                        renderingGroupId:1,
                        pickable: false,

                    },

                    geo_sw_sn_2:{
                        visibility:0,
                        renderingGroupId:1,
                        pickable: false,
                    },

                    geo_sw_th_1:{
                        visibility:0,
                        renderingGroupId:2,
                        pickable: false,

                    },

                    geo_sw_th_2:{
                        visibility:0,
                        renderingGroupId:2,
                        pickable: false,
                    },

                    geo_sw_bw_1:{
                        visibility:0,
                        renderingGroupId:1,
                        pickable: false,

                    },
                    geo_sw_bw_2:{
                        visibility:0,
                        renderingGroupId:1,
                        pickable: false,
                    },

                    geo_sw_by_1:{
                        visibility:0,
                        renderingGroupId:1,
                        pickable: false,

                    },
                    geo_sw_by_2:{
                        visibility:0,
                        renderingGroupId:1,
                        pickable: false,
                    },


                    // 3D-Typo             

                    geo_typo_belgien:{
                        visible: false,
                        visibility:0,
                    },

                    geo_typo_niederlande:{
                        visible: false,
                        visibility:0,
                    },

                    geo_typo_daenemark:{
                        visible: false,
                        visibility:0,
                    },

                    geo_typo_polen:{
                        visible: false,
                        visibility:0,
                    },

                    geo_typo_tschechien:{
                        visible: false,
                        visibility:0,
                    },

                    geo_typo_oesterreich:{
                        visible: false,
                        visibility:0,
                    },

                    geo_typo_schweiz:{
                        visible: false,
                        visibility:0,
                    },

                    geo_typo_frankreich:{
                        visible: false,
                        visibility:0,
                    },

                    geo_typo_frankreich_2:{
                        visible: false,
                        visibility:0,
                    },
                    
                    geo_typo_luxemburg:{
                        visible: false,
                        visibility:0,
                    },

                    geo_typo_ostsee:{
                        visible: false,
                        visibility:0,
                    },

                    geo_typo_ostsee_2:{
                        visible: false,
                        visibility:0,
                    },

                    geo_typo_nordsee:{
                        visible: false,
                        visibility:0,
                    },


                    geo_typo_schweden:{
                        visible: false,
                        visibility:0,
                    },
                    

                    geo_bus:{
                        visible: false,
                        visibility:0,
                        scaling:[0,0,0],
                    },                    

                    



                },
            },

            // Callback wenn Objekt geladen und erstellt wurde zum setzen weiterer Einstellungen.
            callback: function (karte) // eslint-disable-line no-unused-vars
            {


            // let MAT_sl = this.scene.getNodeByName('geo_sl').material;
            // MAT_sl.disableLighting = true;
            // MAT_sl.separateCullingPass = true;
            
            // let MAT_rp = this.scene.getNodeByName('geo_rp').material;
            // MAT_rp.disableLighting = true;
            // MAT_rp.separateCullingPass = true;

            // let MAT_he = this.scene.getNodeByName('geo_he').material;
            // MAT_he.disableLighting = true;
            // MAT_he.separateCullingPass = true;

            // let MAT_nw = this.scene.getNodeByName('geo_nw').material;
            // MAT_nw.disableLighting = true;
            // MAT_nw.separateCullingPass = true;

            let MAT_hand = this.scene.getNodeByName('geo_hand_01').material;
            MAT_hand.disableLighting = true;
            MAT_hand.separateCullingPass = true;


            let MAT_deutschland = this.scene.getNodeByName('geo_deutschland').material;
            MAT_deutschland.disableLighting = true;

            let MAT_Marker = this.scene.getNodeByName('geo_marker_01').material;
            MAT_Marker.disableLighting = true;

            }
        },
        //  {
        //      name: "lava",
        //      filename: "lava_keyframes_code_philipp.glb", // https://3d.zdf.de/coronavirus/3d-models/mdl_virus_016.glb
        //      options: {
        //          visible: false,
        //          position: [0, 0, 0],
        //          scaling: [.1, .1, .1],
        //          rotation: [0, 0, 0],
        //      },
        //  },
        // {
        //     name: "MarsHeli",
        //     // filename: "Ingenuity.glb",
        //     filename: "001_MarsHeli_Kemweb_Hierarchy_Test.glb",
        //     options: {
        //         visible: false,
        //         position: [0, 0, 0],
        //         scaling: [.1, .1, .1],
        //         rotation: [0, 0, 0],
        //     },
        // },
    ]
};
